(function () {
const $878101575badcebe$var$solutionTileCarousel = new Swiper('.solution-tile-carousel-swiper', {
    speed: 1500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    grid: {
        fill: 'row',
        rows: 12
    },
    spaceBetween: 60,
    autoplay: {
        enabled: false,
        delay: 10000,
        waitForTransition: false
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
            return '<span class="' + className + '">' + '<span class="progress"></span>' + '</span>';
        }
    },
    breakpoints: {
        992: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            grid: {
                fill: 'row',
                rows: 2
            }
        }
    }
});

})();
//# sourceMappingURL=solutionTileCarousel.js.map
